<template>
  <v-app-bar
    class="px-3"
    color="white"
    height="66"
    style="border-bottom: 1px solid #e0e0e0">
    <div class="d-flex align-center gap-4" style="min-width: 271px">
      <v-btn
        icon="mdi-menu"
        @click="$emit('update:isExpanded', !isExpanded)"></v-btn>
      <div class="d-flex align-center mr-10">
        <RouterLink class="text-none d-flex align-center" to="/eds">
          <new-logo-black />
        </RouterLink>
      </div>

      <v-menu v-if="can('documents.create')" :close-on-content-click="false">
        <template #activator="{ props }">
          <v-btn
            color="light-blue-darken-4"
            icon="mdi-file-document-plus-outline"
            v-bind="props"
            @click="
              $directory.fill(['docTypeClasses', 'docTypeDefinitions'])
            "></v-btn>
        </template>

        <v-card width="350">
          <div class="font-weight-bold text-disabled text-uppercase pa-2 px-4">
            Створити
          </div>

          <v-menu
            v-for="docTypeClass in $directory.get('docTypeClasses')"
            :key="docTypeClass.id"
            location="right"
            open-on-hover>
            <template #activator="{ props }">
              <v-list-item v-bind="props">
                <div
                  class="d-flex justify-space-between align-center font-size-15">
                  <div>{{ docTypeClass.name }}</div>

                  <v-icon color="grey" icon="mdi-chevron-right"></v-icon>
                </div>
              </v-list-item>
            </template>

            <v-card width="350">
              <v-list-item
                v-for="type in $directory
                  .get('docTypeDefinitions')
                  .filter(t => t.docTypeClassId === docTypeClass.id)"
                :key="type.id"
                @click="
                  confirmDocumentCreate(
                    docTypeClass.id as number,
                    type.id as number,
                    type.name
                  )
                ">
                <v-icon
                  class="mr-3"
                  color="#1a7a4a"
                  icon="mdi-file-outline"></v-icon>
                {{ type.name }}
              </v-list-item>
            </v-card>
          </v-menu>
        </v-card>
      </v-menu>
    </div>
    <v-row class="align-center w-100 py-2">
      <v-col v-if="$vuetify.display.mdAndUp" class="pl-0 pb-0 pt-0" cols="6">
        <global-search></global-search>
      </v-col>

      <v-col class="pb-0 pt-0" cols="9" md="6">
        <div class="d-flex align-center gap-2 justify-end">
          <v-menu
            v-if="
              [
                can('modules.documentflow'),
                can('modules.administration'),
                can('modules.operation-risks'),
                can('modules.tasks'),
                can('modules.audit'),
                can('modules.documentAgreements'),
              ].filter(Boolean).length > 1
            "
            location="bottom end"
            offset-y
            transition="scale-transition">
            <template #activator="{ props }">
              <v-btn :border="false" icon v-bind="props">
                <menu-icon />
              </v-btn>
            </template>

            <v-card class="mode-switcher">
              <div>
                <div
                  v-if="can('modules.documentflow')"
                  class="mode-item"
                  @click="$router.push({ name: 'home' })">
                  <div class="mode-item__icon mode-item__icon--blue">
                    <v-icon size="20">mdi-file-document-outline</v-icon>
                  </div>

                  <div class="mode-item__content">
                    <div class="mode-item__title">Документообіг</div>
                    <div class="mode-item__subtitle">
                      Документи, завдання, аудит
                    </div>
                  </div>

                  <v-icon
                    v-if="isRouteSectionActive('eds')"
                    class="mode-item__check">
                    mdi-check
                  </v-icon>
                </div>

                <div
                  v-if="can('modules.administration')"
                  class="mode-item"
                  @click="$router.push({ name: 'administration' })">
                  <div class="mode-item__icon mode-item__icon--gray">
                    <v-icon size="20">mdi-cog-outline</v-icon>
                  </div>

                  <div class="mode-item__content">
                    <div class="mode-item__title">Адміністрування</div>
                    <div class="mode-item__subtitle">Структура, довідники</div>
                  </div>

                  <v-icon
                    v-if="isRouteSectionActive('administration')"
                    class="mode-item__check">
                    mdi-check
                  </v-icon>
                </div>

                <div
                  v-if="can('modules.operation-risks')"
                  class="mode-item"
                  @click="$router.push({ name: 'operation-risk' })">
                  <div class="mode-item__icon mode-item__icon--error">
                    <v-icon size="20">mdi-alert-outline</v-icon>
                  </div>

                  <div class="mode-item__content">
                    <div class="mode-item__title">Операційні ризики</div>
                    <div class="mode-item__subtitle">Реєстр інцидентів</div>
                  </div>

                  <v-icon
                    v-if="isRouteSectionActive('operation-risk')"
                    class="mode-item__check">
                    mdi-check
                  </v-icon>
                </div>

                <div
                  v-if="can('modules.tasks')"
                  class="mode-item"
                  @click="$router.push({ name: 'task-dashboard' })">
                  <div class="mode-item__icon mode-item__icon--warning">
                    <v-icon size="20">mdi-calendar-check</v-icon>
                  </div>

                  <div class="mode-item__content">
                    <div class="mode-item__title">Завдання</div>
                    <div class="mode-item__subtitle">
                      Управління завданнями та резолюціями
                    </div>
                  </div>

                  <v-icon v-if="isTaskSectionActive" class="mode-item__check">
                    mdi-check
                  </v-icon>
                </div>

                <div
                  v-if="can('modules.audit')"
                  class="mode-item"
                  @click="$router.push({ name: 'audit-section' })">
                  <div class="mode-item__icon mode-item__icon--purple">
                    <v-icon size="20">mdi-calendar-check</v-icon>
                  </div>
                  <div class="mode-item__content">
                    <div class="mode-item__title">Аудит</div>
                    <div class="mode-item__subtitle">
                      Плани, аудити та рекомендації
                    </div>
                  </div>
                  <v-icon
                    v-if="isRouteSectionActive('audit-section')"
                    class="mode-item__check">
                    mdi-check
                  </v-icon>
                </div>

                <div
                  v-if="can('modules.documentAgreements')"
                  class="mode-item"
                  @click="$router.push({ name: 'document-agreement-dashboard' })">
                  <div class="mode-item__icon mode-item__icon--blue">
                    <v-icon size="20">mdi-file-document-outline</v-icon>
                  </div>

                  <div class="mode-item__content">
                    <div class="mode-item__title">Договори</div>
                    <div class="mode-item__subtitle">
                      Погодження договорів із системи БЕСТ24
                    </div>
                  </div>

                  <v-icon
                    v-if="isRouteSectionActive('document-agreement')"
                    class="mode-item__check">
                    mdi-check
                  </v-icon>
                </div>
              </div>
            </v-card>
          </v-menu>
          <notification-template></notification-template>
          <v-divider class="mx-1 my-2" vertical></v-divider>
          <user-actions></user-actions>
        </div>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script lang="ts">
import NotificationTemplate from '@/components/notifications/Notifications.vue'
import { computed, PropType } from 'vue'
import { useStore } from 'vuex'
import GlobalSearch from './global-search/GlobalSearch.vue'
import MenuIcon from '@/assets/images/icons/menu-icon.vue'
import { USER_ROLE } from '@/utils/constants'
import NewLogoBlack from '@/components/icon/icons/black-new-logo.vue'
import UserActions from '@/components/the-header/user/UserActions.vue'
import { useRoute, useRouter } from 'vue-router'
import { documentCreate as documentCreateRequest } from '@/requests/document'
import { useCan } from '@/composables/useCan'
import { confirm } from 'best-modules/plugins'

export default {
  components: {
    UserActions,
    NewLogoBlack,
    MenuIcon,
    NotificationTemplate,
    GlobalSearch,
  },
  emits: ['update:isExpanded'],
  props: {
    viewMode: {
      type: String as PropType<'full' | 'small'>,
      default: 'full',
      validator: val => ['full', 'small'].includes(val as string),
    },
    isExpanded: { type: Boolean },
  },
  data() {
    return {
      USER_ROLE,
    }
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const { can } = useCan()
    const user = computed(() => store.state.user.userData || {})
    const isRouteSectionActive = (routeName: string) => {
      return route.matched.some(item => item.name === routeName)
    }
    const isTaskSectionActive = computed(() => {
      return route.matched.some(item => ['tasks', 'task'].includes(item.name))
    })

    const documentCreate = (classId: number, typeId: number) => {
      return documentCreateRequest({
        docTypeClassId: classId,
        docTypeDefinitionId: typeId,
      }).then(res => {
        return router.push({
          name: 'document-single',
          params: { uuid: res.uuid },
        })
      })
    }

    const confirmDocumentCreate = (
      classId: number,
      typeId: number,
      typeName: string
    ) => {
      return confirm({ text: `Створити документ "${typeName}"?` }).then(() =>
        documentCreate(classId, typeId)
      )
    }

    return {
      user,
      route,
      documentCreate,
      confirmDocumentCreate,
      isRouteSectionActive,
      isTaskSectionActive,
      can,
    }
  },
}
</script>

<style lang="scss" scoped>
.mode-item {
  position: relative;
  width: 300px;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 12px 18px;
  cursor: pointer;
  transition: background 0.12s;

  &:not(&:last-child):after {
    content: '';
    position: absolute;
    width: 272px;
    height: 1px;
    left: 14px;
    bottom: 0;
    background: #f0f0f5;
  }

  &:hover {
    background: #f5f6fa;
  }

  &__icon {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    &--blue {
      background: #e6f1fb;

      .v-icon {
        color: #185fa5;
      }
    }

    &--gray {
      background: #f5f5f9;

      .v-icon {
        color: #6c6c7d;
      }
    }

    &--error {
      background: #fff0f0;

      .v-icon {
        color: rgb(192, 57, 43);
      }
    }

    &--warning {
      background: #fff0c5;

      .v-icon {
        color: #c49200;
      }
    }

    &--purple {
      background: #ede6ff;

      .v-icon {
        color: #8255ff;
      }
    }
  }

  &__content {
    flex: 1;
    min-width: 0;
  }

  &__title {
    font-size: 14px;
    font-weight: 600;
    color: #1a1a1b;
  }

  &__subtitle {
    font-size: 12px;
    color: #9898a8;
    margin-top: 1px;
  }

  &__check {
    color: #185fa5;
    flex-shrink: 0;
  }
}
</style>
